import { IEvent } from "../../models/event";
import { Event } from "../models/gqlModels";

export function mapGraphQLEventToIEvent(gqlEvent: Event, studentId?: string): IEvent {
    return {
        id: gqlEvent.id || '',
        name: gqlEvent.title || '',
        start: new Date(gqlEvent.calendarStartDate),
        end: new Date(gqlEvent.calendarEndDate),
        type: gqlEvent.type || 'free',
        picture: '', // Not available in GraphQL response
        description: gqlEvent.description || '',
        location: {
            name: gqlEvent.venue || '',
            school: gqlEvent.school || '',
            address: '',
            city: '',
            province: '',
            country: '',
            postalCode: '',
            latitude: 0,
            longitude: 0
        },
        pricing: {
            currency: 'ZAR', // Default currency
            adults: 0,
            children: 0
        },
        attendance: {
            attendanceStatus: null,
            adults: 0,
            children: 0,
            hasPaid: false
        },
        result: '', // Can be populated for sporting events
        studentIds: studentId ? [studentId] : [], // Array of associated student IDs
        relatedField: {
            type: 'School',
            id: gqlEvent.school || gqlEvent.schoolCode || ''
        }
    };
}